import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from '../../../constant';
import { Link, useNavigate } from "react-router-dom";

const WarehouseTransactionMaster = () => {
  const tableHeaders = ["#",  "Transaction Date", "Transaction Type", "Reference Number", "Created By","Remarks" , "Action"];
    const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
  id: null,
  warehouse_id: 1,
  trxn_date: '',
  trxn_type: '',        
  reference_number: '',  
  remarks: '',
  created_by: userId || '',
});

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

 // 🔹 Define options with id/value
const trxnTypeOptions = [
  { value: 1, label: 'IN' },
  { value: 2, label: 'INSTORE-OUT' },
  { value: 3, label: 'APPSTORE-OUT' },
  { value: 4, label: 'WASTAGE' },
  { value: 5, label: 'ADJUSTMENT' },
];

const referenceNumberOptions = [
  { value: 1, label: 'GRN' },
  { value: 2, label: 'INSTORE SALE' },
  { value: 3, label: 'APPSTORE SALE' },
  { value: 4, label: 'DAMAGE' },
  { value: 5, label: 'ADJUST' },
];


  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      setInitialLoading(true);
      await fetchData();
    } catch {
      toast.error("Error loading data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const res = await axios.get(`${var_api}veemart_warehouse_inventory_transaction/get`);
      setData(res.data || []);
    } catch {
      toast.error("Failed to fetch transaction data");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

 const handleSelectChange = (selectedOption, name) => {
  setFormData(prev => ({ ...prev, [name]: selectedOption?.value || '' }));
  setErrors(prev => ({ ...prev, [name]: '' }));
};
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};


  const handleAddClick = () => {
    setFormData({
      id: null,
      warehouse_id: 1,
      trxn_date: '',
      trxn_type: '',
      reference_number : '',
      remarks: '',
  created_by: userId || '',
    });
    setIsEditMode(false);
    setErrors({});
    setShowModal(true);
  };

  const handleEditClick = (item) => {
  const formattedDate = item.trxn_date
    ? new Date(item.trxn_date).toISOString().split("T")[0]
    : "";

  setFormData({
    ...item,
    trxn_date: formattedDate, // ✅ fix here
    trxn_type: Number(item.trxn_type),
    reference_number: Number(item.reference_number),
  });
  setIsEditMode(true);
  setErrors({});
  setShowModal(true);
};



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const newErrors = {};
    if (!formData.trxn_date) newErrors.trxn_date = "Transaction date is required";
    if (!formData.trxn_type) newErrors.trxn_type = "Transaction type is required";
    if (!formData.reference_number ) newErrors.reference_number = "Reference number is required";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please correct the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}veemart_warehouse_inventory_transaction/update/${formData.id}`, formData);
      } else {
        res = await axios.post(`${var_api}veemart_warehouse_inventory_transaction/post`, formData);
      }
      toast.success(res?.data?.message || "Transaction saved successfully!");
      setShowModal(false);
      fetchData();
    } catch (err) {
      if (err?.response?.data?.errors) setErrors(err.response.data.errors);
      toast.error(err?.response?.data?.message || "Failed to save transaction");
    } finally {
      setLoading(false);
    }
  };

  const getLabel = (options, value) => {
  const found = options.find(o => String(o.value) === String(value));
  return found ? found.label : '-';
};



const filteredData = data.filter(item => {
  const search = searchQuery.toLowerCase();

  const trxnTypeLabel = getLabel(trxnTypeOptions, item.trxn_type).toLowerCase();
  const referenceLabel = getLabel(referenceNumberOptions, item.reference_number).toLowerCase();

  return (
    String(formatDate(item.trxn_date)).toLowerCase().includes(search) ||
    trxnTypeLabel.includes(search) ||
    referenceLabel.includes(search) ||
    (item.remarks && item.remarks.toLowerCase().includes(search)) ||
    (userName && userName.toLowerCase().includes(search))
  );
});


  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search transaction..."
                  value={searchQuery}
                  onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                />
                <Button variant="secondary" onClick={handleAddClick}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => (<th key={idx}>{header}</th>))}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan={tableHeaders.length} className="text-center text-muted py-3">No data found</td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                         <td>{formatDate(item.trxn_date)}</td>
                         <td>{getLabel(trxnTypeOptions, item.trxn_type)}</td>
                         <td>{getLabel(referenceNumberOptions, item.reference_number)}</td>
                          <td>{userName || "-"}</td>

                          <td>{item.remarks}</td>
                          <td className="text-center">
                            <Link
                                                        to="#"
                                                        className="btn shadow btn-xs sharp me-1"
                                                        style={{ backgroundColor: "#007bff", color: "white" }}
                                                        onClick={() => handleEditClick(item)}
                                                      >
                                                        <i className="fas fa-pencil-alt"></i>
  </Link>

   <Button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#28a745", color: "white" }}
  title="View Transaction"
  onClick={() => {
    // Store all necessary field values in localStorage
    localStorage.setItem("transaction_id", item.id);
    localStorage.setItem("warehouse_id", item.warehouse_id);
    localStorage.setItem("trxn_date", item.trxn_date);
    localStorage.setItem("trxn_type", item.trxn_type);
    localStorage.setItem("reference_number", item.reference_number);
    localStorage.setItem("remarks", item.remarks);
    localStorage.setItem("created_by", item.created_by);

    // Navigate to the transaction details page
    navigate(`/warehouse-transaction-details`);
  }}
>
<i className="fas fa-file-invoice"></i></Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end mt-3">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      onClick={() => setCurrentPage(idx + 1)}
                      className="me-1"
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Transaction" : "Add Transaction"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
               

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Transaction Date <span className="text-danger">*</span></Form.Label>
                    <Form.Control type="date" name="trxn_date" value={formData.trxn_date} onChange={handleInputChange} />
                    {errors.trxn_date && <div className="text-danger small mt-1">{errors.trxn_date}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Transaction Type <span className="text-danger">*</span></Form.Label>
                    <Select
                      options={trxnTypeOptions}
                      value={trxnTypeOptions.find(o => o.value === formData.trxn_type) || null}
                      onChange={(option) => handleSelectChange(option, 'trxn_type')}
                      isSearchable
                      placeholder="Select transaction type"
                    />
                    {errors.trxn_type && <div className="text-danger small mt-1">{errors.trxn_type}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Reference Number <span className="text-danger">*</span></Form.Label>
                    <Select
                      options={referenceNumberOptions}
                      value={referenceNumberOptions.find(o => o.value === formData.reference_number) || null}
                      onChange={(option) => handleSelectChange(option, 'reference_number')}
                      isSearchable
                      placeholder="Select reference"
                    />
                    {errors.reference_number && <div className="text-danger small mt-1">{errors.reference_number}</div>}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Remarks</Form.Label>
                    <Form.Control type="text" name="remarks" value={formData.remarks} onChange={handleInputChange} placeholder="Enter remarks" />
                  </Form.Group>
                </Col>

              
              </Row>

              <div className="d-flex justify-content-end gap-2">
                {!isEditMode ? (
                  <>
                    <Button variant="secondary" type="submit" disabled={loading}>
                      {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Creating...</> : "Create"}
                    </Button>
                    <Button variant="danger" type="reset" onClick={handleAddClick} disabled={loading}>Reset</Button>
                  </>
                ) : (
                  <>
                    <Button variant="warning" type="submit" disabled={loading}>
                      {loading ? <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Updating...</> : "Update"}
                    </Button>
                    <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>Cancel</Button>
                  </>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Card>

      <ToastContainer />
    </>
  );
};

export default WarehouseTransactionMaster;
